import { Component, inject } from '@angular/core';
import { PrimaryInputComponent } from "../../../components/input/primary-input/primary-input.component";
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../services/auth/auth.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ImagesService } from '../../../services/general/images.service';
import { ToastService } from '../../../services/general/toast.service';

@Component({
  selector: 'app-login',
  imports: [
    PrimaryInputComponent,
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  _router = inject(Router);
  _fb = inject(FormBuilder);
  isLoading: boolean = false;
  showPassword: boolean = false;
  authService = inject(AuthService);
  _images = inject(ImagesService);
  _toast = inject(ToastService);
  currentYear: number = new Date().getFullYear();

  loginData: FormGroup = this._fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });

  togglePasswordVissibility() {
    this.showPassword = !this.showPassword;
  }


  loginUser() {

    if (this.loginData.valid) {
      this.isLoading = true; // Set loading state to true
      this.authService.loginPost(this.loginData.value).subscribe({
        next: (res) => {
          this.authService.setAuthState(res);
          localStorage.setItem('userInfo', JSON.stringify(res));
          localStorage.setItem('tokenn', res.accessToken || '');
          this._toast.success("Login successfully")
          // Navigate to the dashboard after successful login
          this.authService.getAuthToken();
          this._router.navigate(['dashboard']);
          this.isLoading = false; // Reset loading state
        },
        error: (error) => {
          this._toast.error("Invalid email or password!")
          console.error('Login failed:', error);
          this.isLoading = false; // Reset loading state
          // Handle error appropriately, e.g., show a notification
        }
      });
    } else {
      console.error('Form is invalid');
      this._toast.error("Invalid email or password!")
      this.isLoading = false;
      this.loginData.markAllAsTouched(); // Mark all fields as touched to show validation errors
      // Handle form validation errors, e.g., show a notification
    }
  }

  // routeToDashboard() {
  //   this._router.navigate(['workspace/dashboard']);
  // }

  goToForgotPassword() {
    this._router.navigate(['auth/forgot-password']);
  }

}
